export default "__VITE_ASSET__5fhyjGtF__"